import { useState } from "react"

export const Toast = ({ message, error, success }) => {
    const [isOpen, setIsOpen] = useState(true);
    return (
        isOpen && (
            <div className={success ? "absolute top-8 right-8 bg-[green] p-6 flex rounded gap-8" : "absolute top-8 right-8 bg-[red] p-6 flex rounded gap-8"} role="status">
                <h1>{message}</h1>
                <button className="btn" onClick={() => setIsOpen(!isOpen)}>x</button>
            </div>
        )
    )
}